import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddSubCategory = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [isError, setError] = useState(false);
  const [categoryDrp, setCategoryDrpData] = useState([]);
  const [dealerData, setDealerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    category_id: "",
    image: "",
    image_url: "",
    dealer_id: 0,
  });

  const getCategory = () => {
    axios.post(API_URL.CATEGORY_LIST, { dealer_id: formValue.dealer_id }).then((res) => {
      setCategoryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCategoryDrpData(cd);
    });
  };

  const getDealer = () => {
    setLoading(true);
    axios.post(API_URL.USERS_DEALERS, {}).then(
      (res) => {
        if (res.data.status === 1) {
          let cd = res.data.data.map((caw) => {
            return {
              label: caw.name + " - " + caw.contact_no,
              value: caw.id,
            };
          });
          setDealerData(cd);
        }
        setLoading(false);
      }
    );
  };
  
  const onSave = () => {
    if (formValue.name &&
      formValue.category_id
    ) {
      if (!id && !formValue.image) {
        setError(true);
        toast.error("Please enter valid details", {
          autoClose: 3000,
        });
        return false;
      }
      setError(false);
      setLoading(true);
      var prodFormData = new FormData();
      if (formValue.image) {
        prodFormData.append("image", formValue.image);
      }
      const pUrl = id ? API_URL.SUB_CATEGORY_UPDATE : API_URL.SUB_CATEGORY_SAVE;
      axios.post(pUrl, formValue).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Sub Category Updated Successfully."
            : "Sub Category Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/subcategory");
        }
      })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  const onEdit = () => {
    axios.post(API_URL.SUB_CATEGORY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          image: null,
          category_id: res.data.data.category_id
            ? res.data.data.category_id
            : "",
          image_url: res.data.data.image ? res.data.data.image : "",
          dealer_id: res.data.data.dealer_id ? res.data.data.dealer_id : 0,
        });
      }
    });
  };

  useEffect(() => {
    getDealer();
  }, []);

  useEffect(() => {
    formValue.dealer_id && getCategory();
  }, [formValue.dealer_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-4">
          <h1>{id ? "Edit" : "Add"} SubCategory</h1>
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/subcategory"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form>
                <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Dealer<span className="required-star">*</span></label>
                      <Select
                        options={dealerData}
                        value={dealerData.find((r) => r.value == formValue.dealer_id)}
                        onChange={(e) => setFormValue({ ...formValue, dealer_id: e.value })}
                        placeholder="Select Dealer"
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-md-4 col-sm-12">
                    <div className="form-group">
                      <label>
                        Category<span className="required-star">*</span>
                      </label>
                      <Select
                        options={categoryDrp}
                        value={categoryDrp.find(
                          (r) => r.value === formValue.category_id
                        )}
                        styles={
                          isRequiredField("category_id")
                            ? customRequireStyles
                            : customStyles
                        }
                        onChange={(e) => {
                          setFormValue({ ...formValue, category_id: e.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formValue.name}
                        className={
                          isRequiredField("name")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="name"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Image<span className="required-star">*</span></label>
                          <div
                            className={isRequiredField("image") ? "required-box": ""}
                          >
                            <Crop
                              imagePreview={imagePreview}
                              cropShape={"round"}
                              guid={""}
                              onChangeCropper={async ({
                                fileCropped,
                                fileCroppedBase64,
                              }) => {
                                setFormValue({
                                  ...formValue,
                                  image: fileCroppedBase64,
                                });
                                setImagePreview(fileCroppedBase64);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {id && (
                        <div className="col-md-12">
                          <label>Preview</label>
                          <div>
                            <a
                              href={formValue.image_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={formValue.image_url}
                                height={100}
                                width={100}
                                alt="product_image"
                              />
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubCategory;
